module.exports = __webpack_public_path__ + "media/images/category/japanese-culture-481146602f19d5e34f31ef04bd2444b6.svg";